import { composeIO } from 'react-compose-io'
import { cabecalhoIO } from './Cabecalho.IO'
import { CabecalhoView } from './Cabecalho.View'

export const Cabecalho = composeIO(CabecalhoView, cabecalhoIO)
